import React from 'react';
import { List, Grid } from 'lucide-react';

interface ListGridViewToggleProps {
  view: 'list' | 'grid';
  setView: (view: 'list' | 'grid') => void;
}

const ListGridViewToggle: React.FC<ListGridViewToggleProps> = ({ view, setView }) => {
  return (
    <div className="flex items-center space-x-2">
      <button
        onClick={() => setView('list')}
        className={`p-2 rounded-md transition-colors ${
          view === 'list' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-600'
        }`}
        aria-label="List view"
      >
        <List size={20} />
      </button>
      <button
        onClick={() => setView('grid')}
        className={`p-2 rounded-md transition-colors ${
          view === 'grid' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-600'
        }`}
        aria-label="Grid view"
      >
        <Grid size={20} />
      </button>
    </div>
  );
};

export default ListGridViewToggle;